import { render } from "./AdminPropertyDuplicates.vue?vue&type=template&id=3bedbb3e&scoped=true"
import script from "./AdminPropertyDuplicates.vue?vue&type=script&lang=js"
export * from "./AdminPropertyDuplicates.vue?vue&type=script&lang=js"

import "./AdminPropertyDuplicates.vue?vue&type=style&index=0&id=3bedbb3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bedbb3e"]])

export default __exports__